import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  findAllSignetExampleListPageable,
  downloadExample,
  uploadSignetExample,
} from '../../actions/signetExample';
import { TablePagination } from '@material-ui/core';
import withTranslations from '../../utils/HighOrderComponent';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import {
  numberOfItemsPerPage,
  rowsPerPageOptions,
} from '../../constants/globals.js';
import { changePaginationTextToSerbian } from '../../utils';
import SignetExampleTable from '../SignetExample/SignetExampleTable';

class SignetExampleList extends Component {
  constructor() {
    super();
    this.state = {
      activePage: 0,
      numberOfItemsPerPage: numberOfItemsPerPage,
      show: false,
    };
  }
  componentDidMount() {
    this.props.findAllSignetExampleListPageable(
      0,
      this.state.numberOfItemsPerPage
    );
  }
  handlePageChange = (event, value) => {
    this.setState({
      activePage: value,
    });
    this.props.findAllSignetExampleListPageable(
      value,
      this.state.numberOfItemsPerPage
    );
  };

  handleChangeRowsPerPage = (event, value) => {
    this.props.findAllSignetExampleListPageable(0, event.target.value);
    this.setState({
      numberOfItemsPerPage: event.target.value,
      activePage: 0,
    });
  };

  handleShowModal = () => {
    this.setState({ show: true });
  };
  handlePreviewClose = () => {
    this.setState({ show: false });
  };

  render() {
    const { signetExample, downloadExample, t, uploadSignetExample } =
        this.props || {},
      { signetExampleList, totalElements, loading } = signetExample || {};

    if (loading) {
      return <LoadingIndicator />;
    }

    return (
      <div className="wrapper-fade-in content-min-height mb-5 mt-2">
        <div className="container">
          <SignetExampleTable
            signetExampleList={signetExampleList}
            downloadExample={downloadExample}
            uploadSignetExample={uploadSignetExample}
            handleShowModal={this.handleShowModal}
            handlePreviewClose={this.handlePreviewClose}
            show={this.state.show}
          />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <TablePagination
              component="div"
              count={Number(totalElements)}
              page={this.state.activePage}
              onPageChange={this.handlePageChange}
              rowsPerPageOptions={rowsPerPageOptions}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              rowsPerPage={this.state.numberOfItemsPerPage}
              labelRowsPerPage={t.rowPerPage}
              labelDisplayedRows={(obj) =>
                changePaginationTextToSerbian(obj, t.of)
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  signetExample: state.signetExample,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllSignetExampleListPageable: (pageNumber, pageSize) => {
      dispatch(findAllSignetExampleListPageable(pageNumber, pageSize));
    },
    downloadExample: (message) => {
      dispatch(downloadExample(message));
    },
    uploadSignetExample: (data, callback, notificationMessages) => {
      dispatch(uploadSignetExample(data, callback, notificationMessages));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(SignetExampleList, 'SignetExampleList'));
